import { createFileRoute } from '@tanstack/react-router';
import { PlansPage } from '@/features/messaging/pages/plans-page';

export const Route = createFileRoute('/_app/messages/plans')({ component: PlansPage });
